<template id="">
  <div class="row">
    <b-table-simple>
      <b-tr v-for="setting of displaySettings" :key="setting.key">
        <b-td>
          <h3 v-label-key="setting.value"></h3>
          <p v-if="setting.chains && setting.chains.length">
            <span>{{ enabledCountLabel(setting.chains.length) }}: </span>
            <ul>
              <li v-for="chain of setting.chains" :key="`${chain.id}-${setting.value}`">{{chain.name}}</li>
            </ul>
          </p>
        </b-td>
        <b-td class="text-right">
          <b-button variant="success" @click="enable(setting.key)">
            <span v-label-key="'ENABLE_SETTING_CHILD_CHAINS'">Enable for all child chains</span>
          </b-button>
          <b-button class="ml-2" variant="danger" @click="disable(setting.key)">
            <span v-label-key="'DISABLE_SETTING_CHILD_CHAINS'">Disable for all child chains</span>
          </b-button>
        </b-td>
      </b-tr>
    </b-table-simple>
  </div>
</template>
<script>
import $api from '@/services/api';
import { mapGetters } from 'vuex';

const confirmLabels = {
  distributor: {
    enable: 'ENABLE_DISTRIBUTOR_CHAIN_SETTING',
    disable: 'DISABLE_DISTRIBUTOR_CHAIN_SETTING',
  },
  subdistributor: {
    enable: 'ENABLE_SUBDISTRIBUTOR_CHAIN_SETTING',
    disable: 'DISABLE_SUBDISTRIBUTOR_CHAIN_SETTING',
  },
};
const alertLabels = {
  distributor: {
    enable: 'ENABLED_DISTRIBUTOR_CHAIN_SETTING',
    disable: 'DISABLED_DISTRIBUTOR_CHAIN_SETTING',
  },
  subdistributor: {
    enable: 'ENABLED_SUBDISTRIBUTOR_CHAIN_SETTING',
    disable: 'DISABLED_SUBDISTRIBUTOR_CHAIN_SETTING',
  },
};

const settings = {
  // Retail app Home page options
  enable_blank_cut: 'CHAIN_SETTING_ENABLE_BLANK_CUT',
  enable_customer_order: 'CHAIN_SETTING_ENABLE_CUSTOMER_ORDER',
  enable_design: 'CHAIN_SETTING_ENABLE_DESIGN',

  // Retail app Menu options
  enable_help: 'CHAIN_SETTING_ENABLE_HELP',
  enable_rankings: 'CHAIN_SETTING_ENABLE_RANKINGS',
  enable_stats: 'CHAIN_SETTING_ENABLE_STATS',
  enable_referrals: 'CHAIN_SETTING_ENABLE_REFERRALS',
  enable_register_fourseasons: 'CHAIN_SETTING_ENABLE_REGISTER_FOUR_SEASONS',

  // Retail app Blank Cut options
  enable_list_recent: 'CHAIN_SETTING_ENABLE_LIST_RECENT',
  enable_list_frequently_used: 'CHAIN_SETTING_ENABLE_LIST_FREQUENTLY_USED',
  enable_list_new: 'CHAIN_SETTING_ENABLE_LIST_NEW',
  enable_list_popular: 'CHAIN_SETTING_ENABLE_LIST_POPULAR',
  enable_list_search: 'CHAIN_SETTING_ENABLE_LIST_SEARCH',

  // Retail app types of templates to display
  // This is now managed by the template types tab
  // enable_templates_air: 'CHAIN_SETTING_ENABLE_TEMPLATES_AIR',
  // enable_templates_back_full: 'CHAIN_SETTING_ENABLE_TEMPLATES_BACK_FULL',
  // enable_templates_front_full: 'CHAIN_SETTING_ENABLE_TEMPLATES_FRONT_FULL',
  // Used for on-demand easy-install
  enable_templates_easy_install: 'CHAIN_SETTING_ENABLE_TEMPLATES_EASY_INSTALL',

  // Retail app options to scan film code or use a bypass credit
  enable_scan_film_code: 'CHAIN_SETTING_ENABLE_SCAN_FILM_CODE',
  enable_bypass_credit: 'CHAIN_SETTING_ENABLE_BYPASS_CREDIT',

  // Retail app staff ID options
  enable_staffid: 'CHAIN_SETTING_ENABLE_STAFF_ID',
  enable_staffid_scan: 'CHAIN_SETTING_ENABLE_STAFF_ID_SCAN',
  enable_staffid_type: 'CHAIN_SETTING_ENABLE_STAFF_ID_TYPE',
  enable_staffid_skip: 'CHAIN_SETTING_ENABLE_STAFF_ID_SKIP',

  // Enable/disable all stores
  // enable_store: 'Enable Store',// Not requested at this point
};

export default {
  computed: {
    displaySettings() {
      return Object.keys(settings).map((key) => ({
        key,
        value: settings[key],
        chains: this.$store.state.global.chains && this.$store.state.global.chains.filter((chain) => (chain[key])),
      }));
      // if (this.$store.state.global.chains) {
      //   console.log(this.$store.state.global.chains);
      // } else {
      //   return [];
      // }
    },
    level() {
      return this.$route.path.includes('subdi') ? 'subdistributor' : 'distributor';
    },
    ...mapGetters('translations', {
      replaceLabel: 'getReplaceLabel',
      getLabel: 'getLabel',
    }),
    enabledCountLabel() {
      // Enabled in ${setting.chains.length} chains
      return (count) => {
        const replacements = {
          '{CHAIN_COUNT}': count,
        };
        return this.replaceLabel('ENABLED_IN_X_CHAINS', replacements);
      };
    },
  },
  methods: {
    async enable(key) {
      await this.pushSetting(key, true);
    },
    async disable(key) {
      await this.pushSetting(key, false);
    },
    async pushSetting(key, enabled) {
      const statusText = enabled ? 'enable' : 'disable';
      const settingsLabel = this.getLabel(settings[key]);

      const confirmLabelKey = confirmLabels[this.level][statusText];
      const confirmLabel = this.replaceLabel(confirmLabelKey, { '{SETTINGS_LABEL}': settingsLabel });

      // eslint-disable-next-line no-restricted-globals, no-alert
      const confirmSetting = confirm(confirmLabel);
      if (!confirmSetting) return;
      try {
        await $api.put(`/v1/dashboard/${this.level}s/${this.$route.params.id}/settings/${key}`, {
          enabled,
        });
        // Reload the chains
        const bodyContent = {};
        bodyContent[`${this.level}_id`] = this.$route.params.id;
        this.$store.dispatch('global/getChains', bodyContent);

        const alertLabelKey = alertLabels[this.level][statusText];
        const alertLabel = this.replaceLabel(alertLabelKey, { '{SETTINGS_LABEL}': settingsLabel });

        // eslint-disable-next-line no-restricted-globals, no-alert
        alert(alertLabel);
      } catch (err) {
        // eslint-disable-next-line no-restricted-globals, no-alert
        alert('There was an error saving the changes.  Please try again later or contact support if the problem persists');
      }
    },
  },
};
</script>
